import { takeLatest, put, all, call } from 'redux-saga/effects'

import api from '~/services/api'

import {
  Types,
  updateStore,
  updateStoreData,
  updateStorePRMSupply,
  updateGetStoreAvailableDates,
  updateSetStoreAvailableDates,
  updateStoreAvailableTimes,
  updateCheckin,
  updateAdjustSupply,
  updateTransferStock,
  updateDestinyStores,
  updateStoreHistory,
  updateZipCodeData
} from './actions'

export function * setStoreData ({ payload }) {
  const { campaignId, storeId, data, redirect } = payload

  if (!campaignId || !storeId) yield put(updateStoreData({ error: 'Ocorreu um erro ao processar a requisição' }))

  const url = `/campaign/${campaignId}/stores/${storeId}`

  try {
    const response = yield call(
      api.put,
      url,
      data
    )

    if (response.status === 200) {
      if (response.data.success && response.data?.data && response.data.data.length > 0) {
        yield put(updateStoreData({ data: response.data.data[0], redirect }))
      } else {
        yield put(updateStoreData({ error: response?.data?.errors[0] || response.data.message }))
      }
    } else {
      yield put(updateStoreData({ error: 'Ocorreu um erro ao processar a requisição' }))
    }
  } catch (error) {
    yield put(updateStoreData({ error: error.message }))
  }
}

export function * getStore ({ payload }) {
  const { campaignId, storeId } = payload

  if (!campaignId || !storeId) yield put(updateStore({ error: 'Ocorreu um erro ao processar a requisição' }))

  const url = `/campaign/${campaignId}/stores/${storeId}/store`

  try {
    const response = yield call(
      api.get,
      url
    )

    if (response.status === 200) {
      if (response.data.success && response.data?.data && response.data.data.length > 0) {
        yield put(updateStore({ store: response.data.data[0] }))
      } else {
        yield put(updateStore({ error: response?.data?.errors[0] || response.data.message }))
      }
    } else {
      yield put(updateStore({ error: 'Ocorreu um erro ao processar a requisição' }))
    }
  } catch (error) {
    yield put(updateStore({ error: error.message }))
  }
}

export function * setStorePRMSupply ({ payload }) {
  const { campaignId, storeId, supply, supplyObs, whatsappRedeemedSupply } = payload

  if (!campaignId || !storeId) yield put(updateStorePRMSupply({ error: 'Ocorreu um erro ao processar a requisição' }))

  const url = `/campaign/${campaignId}/stores/${storeId}`

  const data = {
    redeemedSupply: parseInt(supply) || 0
  }

  if (supplyObs && supplyObs !== '') {
    data.redeemedSupplyObs = supplyObs
  }

  if (whatsappRedeemedSupply && whatsappRedeemedSupply !== '') {
    data.whatsappRedeemedSupply = parseInt(whatsappRedeemedSupply)
  }

  try {
    const response = yield call(
      api.put,
      url,
      data
    )

    if (response.status === 200) {
      if (response.data.success && response.data?.data && response.data.data.length > 0) {
        yield put(updateStorePRMSupply({ data: response.data.data[0] }))
      } else {
        yield put(updateStorePRMSupply({ error: response?.data?.errors[0] || response.data.message }))
      }
    } else {
      yield put(updateStorePRMSupply({ error: 'Ocorreu um erro ao processar a requisição' }))
    }
  } catch (error) {
    yield put(updateStorePRMSupply({ error: error.message }))
  }
}

export function * setZipCodeData ({ payload }) {
  const { zipcode } = payload

  const url = `/store/geolocation/findaddress?zipCode=${zipcode}`

  try {
    const response = yield call(api.get, url)
    if (response.status === 200) {
      if (response.data.success && response.data?.data && response.data.data.length > 0) {
        yield put(updateZipCodeData({ data: response.data.data[0] }))
      } else {
        yield put(updateZipCodeData({ error: response?.data?.message || response.message }))
      }
    } else {
      yield put(updateZipCodeData({ error: 'Ocorreu um erro ao processar a requisição' }))
    }
  } catch (error) {
    yield put(updateZipCodeData({ error: error.message }))
  }
}

export function * setStoreAvailableDates ({ payload }) {
  const { campaignId, storeId, dates: availableDates } = payload

  if (!campaignId || !storeId || !availableDates || availableDates.length === 0) {
    yield put(updateSetStoreAvailableDates({ error: 'Ocorreu um erro ao processar a requisição' }))
  }

  const url = `/campaign/${campaignId}/stores/${storeId}/availability`

  try {
    const response = yield call(
      api.put,
      url,
      {
        availableDates
      }
    )

    if (response.status === 200) {
      if (response.data.success) {
        yield put(updateSetStoreAvailableDates({ respondedAvailableDates: true }))
      } else {
        yield put(updateSetStoreAvailableDates({ error: response?.data?.errors[0] || response.data.message }))
      }
    } else {
      yield put(updateSetStoreAvailableDates({ error: 'Ocorreu um erro ao processar a requisição' }))
    }
  } catch (error) {
    yield put(updateSetStoreAvailableDates({ error: error.message }))
  }
}

export function * getStoreAvailableDates ({ payload }) {
  const { campaignId, storeId } = payload

  if (!campaignId || !storeId) {
    yield put(updateGetStoreAvailableDates({ error: 'Ocorreu um erro ao processar a requisição' }))
  }

  const url = `/campaign/${campaignId}/stores/${storeId}/availability`

  try {
    const response = yield call(
      api.get,
      url
    )

    if (response.status === 200) {
      if (response.data.success && response.data?.data && response.data.data.length > 0) {
        yield put(updateGetStoreAvailableDates({ ...response.data.data[0], ...{ respondedAvailableDates: true } }))
      } else {
        yield put(updateGetStoreAvailableDates({ error: response?.data?.errors[0] || response.data.message }))
      }
    } else {
      yield put(updateGetStoreAvailableDates({ error: 'Ocorreu um erro ao processar a requisição' }))
    }
  } catch (error) {
    yield put(updateGetStoreAvailableDates({ error: error.message }))
  }
}

export function * setStoreAvailableTimes ({ payload }) {
  const { campaignId, storeId, times } = payload

  if (!campaignId || !storeId || !times || times.length < 4) yield put(updateStoreAvailableTimes({ error: 'Ocorreu um erro ao processar a requisição' }))

  const url = `/campaign/${campaignId}/stores/${storeId}/availability`

  try {
    const response = yield call(
      api.put,
      url,
      {
        availableTimes: times
      }
    )

    if (response.status === 200) {
      if (response.data.success) {
        yield put(updateStoreAvailableTimes({ respondedAvailableTimes: true }))
      } else {
        yield put(updateStoreAvailableTimes({ error: response?.data?.errors[0] || response.data.message }))
      }
    } else {
      yield put(updateStoreAvailableTimes({ error: 'Ocorreu um erro ao processar a requisição' }))
    }
  } catch (error) {
    yield put(updateStoreAvailableTimes({ error: error.message }))
  }
}

export function * setCheckin ({ payload }) {
  const { campaignId, storeId } = payload

  if (!campaignId || !storeId) yield put(updateCheckin({ error: 'Ocorreu um erro ao processar a requisição' }))

  const url = `/campaign/${campaignId}/store/${storeId}/checkin`

  try {
    const response = yield call(
      api.post,
      url
    )

    if (response.status === 200) {
      if (response.data.success) {
        yield put(updateCheckin({ respondedCheckin: true }))
      } else {
        yield put(updateCheckin({ error: response?.data?.errors[0] || response.data.message }))
      }
    } else {
      yield put(updateCheckin({ error: 'Ocorreu um erro ao processar a requisição' }))
    }
  } catch (error) {
    yield put(updateCheckin({ error: error.message }))
  }
}

export function * getAdjustSupply ({ payload }) {
  const { campaignId, storeId, reason, supply: newRedeemedSupply, informations } = payload

  if (!campaignId || !storeId || !reason) yield put(updateAdjustSupply({ error: 'Ocorreu um erro ao processar a requisição' }))

  const url = `/campaign/${campaignId}/store/${storeId}/store/recalculateStocks`

  try {
    const response = yield call(
      api.post,
      url,
      {
        reason,
        newRedeemedSupply,
        informations
      }
    )

    if (response.status === 200) {
      if (response.data.success && response.data?.data && response.data.data.length > 0) {
        yield put(updateAdjustSupply({ supply: response.data.data[0] }))
      } else {
        yield put(updateAdjustSupply({ error: response?.data?.errors[0] || response.data.message }))
      }
    } else {
      yield put(updateAdjustSupply({ error: 'Ocorreu um erro ao processar a requisição' }))
    }
  } catch (error) {
    yield put(updateAdjustSupply({ error: error.message }))
  }
}

export function * getTransferStock ({ payload }) {
  const { campaignId, originStore, destinyStore, reason, stockToTransfer, informations } = payload

  if (!campaignId || !originStore || !destinyStore || !stockToTransfer || !reason) yield put(updateAdjustSupply({ error: 'Ocorreu um erro ao processar a requisição' }))

  const url = `/campaign/${campaignId}/store/${originStore}/store/transferStocks`

  try {
    const response = yield call(
      api.post,
      url,
      {
        reason,
        destinyStore,
        stockToTransfer,
        informations
      }
    )

    if (response.status === 200) {
      if (response.data.success && response.data?.data && response.data.data.length > 0) {
        yield put(updateTransferStock({ stock: response.data.data[0] }))
      } else {
        yield put(updateTransferStock({ error: response?.data?.errors[0] || response.data.message }))
      }
    } else {
      yield put(updateTransferStock({ error: 'Ocorreu um erro ao processar a requisição' }))
    }
  } catch (error) {
    yield put(updateTransferStock({ error: error.message }))
  }
}

const fetchStore = (payload) => {
  const { campaignId, storeId, project, allStoresFromSameCp } = payload

  if (!campaignId || !storeId) throw new Error('Ocorreu um erro ao processar a requisição')

  const projectQuery = Array.isArray(project) ? project.join(',') : ''
  const url = `/campaign/${campaignId}/stores/${storeId}/store`

  const params = {
    ...(projectQuery === '' ? {} : { project: projectQuery }),
    ...(allStoresFromSameCp ? { allStoresFromSameCp } : {})
  }

  return call(
    api.get,
    url,
    {
      params
    }
  )
}

export function * getDestinyStores ({ payload }) {
  const response = yield fetchStore(payload)
  try {
    if (response.status === 200) {
      if (response.data.success && response.data?.data?.length) {
        const store = response.data.data[0]
        yield put(updateDestinyStores({ store: store?.storesFromSameCp }))
      } else {
        yield put(updateDestinyStores({ error: response?.data?.errors[0] || response.data.message }))
      }
    } else {
      yield put(updateDestinyStores({ error: 'Ocorreu um erro ao processar a requisição' }))
    }
  } catch (error) {
    yield put(updateDestinyStores({ error: error.message }))
  }
}

export function * getStoreHistory ({ payload }) {
  const response = yield fetchStore(payload)
  try {
    if (response.status === 200) {
      if (response.data.success && response.data?.data?.length) {
        const store = response.data.data[0]
        yield put(updateStoreHistory({ store }))
      } else {
        yield put(updateStoreHistory({ error: response?.data?.errors[0] || response.data.message }))
      }
    } else {
      yield put(updateStoreHistory({ error: 'Ocorreu um erro ao processar a requisição' }))
    }
  } catch (error) {
    yield put(updateStoreHistory({ error: error.message }))
  }
}

export default all([
  takeLatest(Types.getStore, getStore),
  takeLatest(Types.setStoreData, setStoreData),
  takeLatest(Types.setStorePRMSupply, setStorePRMSupply),
  takeLatest(Types.setZipCodeData, setZipCodeData),
  takeLatest(Types.getStoreAvailableDates, getStoreAvailableDates),
  takeLatest(Types.setStoreAvailableDates, setStoreAvailableDates),
  takeLatest(Types.setStoreAvailableTimes, setStoreAvailableTimes),
  takeLatest(Types.setCheckin, setCheckin),
  takeLatest(Types.getAdjustSupply, getAdjustSupply),
  takeLatest(Types.getTransferStock, getTransferStock),
  takeLatest(Types.getDestinyStores, getDestinyStores),
  takeLatest(Types.getStoreHistory, getStoreHistory)
])
